import { ApolloLink } from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';

import { AuthInitializerService } from './auth-initializer.service';
import { HAS_BEARER_TOKEN_CONTEXT_KEY } from '../graphql/transient-hasura-errors';

/**
 * Adds the Auth0 access token to admin-ui GraphQL operations.
 *
 * This Apollo client is authenticated-only. Public admin-ui routes use REST
 * endpoints, while anonymous and Hasura-admin traffic use separate clients.
 * Failing here prevents a missing token from silently downgrading a request to
 * Hasura's anonymous role.
 */
export function createBearerTokenLink(authInitializer: AuthInitializerService): ApolloLink {
  return setContext(async (operation, { headers }) => {
    const token = await authInitializer.getToken();
    if (!token) {
      throw new Error(
        `Cannot dispatch GraphQL operation ${operation.operationName || '<anonymous>'} without an access token`
      );
    }

    return {
      headers: {
        ...headers,
        authorization: `Bearer ${token}`,
      },
      [HAS_BEARER_TOKEN_CONTEXT_KEY]: true,
    };
  });
}
